import { Component, OnInit, Input } from '@angular/core';
import { Supervision, SupervisionReports, InfoSupervis } from 'solar-bo';
import { TableList } from 'shtools';
import { SolarBaseComponent } from '@solar/solar/solar-base';
import { MessageError, NotificationType } from 'base-models';
import { AlertType, } from 'base-models';
import { AppConfig } from '@solar/app.config';
import { environment } from 'projects/solarapp/src/environments/environment';


@Component({
  selector: 'app-rep-supervision',
  templateUrl: './rep-supervision.component.html',
  styleUrls: ['./rep-supervision.component.scss']
})
export class RepSupervisionComponent extends SolarBaseComponent implements OnInit {

  private _supervision: Supervision;
  @Input() get supervision(): Supervision {
    return this._supervision;
  }
  set supervision(value: Supervision) {
    this._supervision = value;
    this.configReportList();
  }
  hasreports:string="INIT";

  private _reports: [];
  @Input()  public get reports(): [] {
    return this._reports;
  }
  public set reports(value: []) {

    this._reports = value;
    this.configReportList();
     if (value && value.length==0 && this.hasreports=="INIT"){
      this.hasreports="EMPTY";
      
    }  else if (value && value.length>0  && this.hasreports=="CHECKED") {
      //this.showNotification(NotificationType.Success, "Supervision reports generated");
    } 
    
  }

  tdata = new TableList<SupervisionReports>();

  get listFiltered(): any[] {
    if (!this.tdata.filteredData){
      return [];
    }
    return this.tdata.filteredData;
  }

  constructor() {
    super();
    this.loadinglist = false;
  }

  ngOnInit() {

  }

  refresh() {
    //this.configReportList();
  }

  configReportList() {
    if (this._reports) {      
      this.tdata.data = this._reports;
    }
    else {
      this.tdata.data = [];
    }

    if (this.tdata.data.length==0){
      this.alertmessage = new MessageError(AlertType.Info,"Sorry there are no reports yet. Reports are generated automatically when supervision status change to Validated.");
    }else{
      this.alertmessage = null;
    }
    
  }

  downloadlink(row):string{
    let site=this._supervision.site;
    return RepSupervisionComponent.ReportUrlByFullFields(row.fullName,site.id,this._supervision.id);
  }

  static ReportUrlByFullFields(filename: string, id_site: string, id_supervision: string): string {
    let u = `/images-supervision/${id_site}/supervisions/${id_supervision}/output/reports/${filename}`;
    u = environment.issueimagebasedir + u;
    return u;
  }



  openitem(item: Supervision) {
    this.router.navigateByUrl(AppConfig.ROUTE_SOLAR + "/site/" + item.id);
    //this.router.navigate(['site/' , item.id],{relativeTo:this.route});
  }

  /**
   * no usar aqui porque no sabe buscar por objetos
   * @param filterValue 
   */
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.tdata.filterData(filterValue);
  }

}
